export default function isValidUsername (str: string): boolean {
  const regex = /^[~`!@#$%^&*()_+=[\]{}|;':",./<>?a-zA-Z0-9-]+$/
  return regex.test(str)
}
